import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import { useDispatch } from 'react-redux';
import { keyEmptyCheck } from 'aurora-utils/utils';
import { ADGMImage, ADGMCheckbox, ADGMAcknowledgementPopup } from 'aurora-components';

import styles from './styles';

function EditablePermissions({ classes, langKeys, permissions, selectedPermissions, changePermissionsHandler }) {
  const dispatch = useDispatch();

  const [openPopup, setOpenPopup] = useState(false);
  const [selectedModulePermissions, setSelectedModulePermissions] = useState([]);

  const handleClosePopup = () => {
    setOpenPopup(false);
    setSelectedModulePermissions([]);
  };
  const handleRemoveModulePermissions = () => {
    const updatedSelectedPermissions = selectedPermissions?.filter(
      selectedPermission => !selectedModulePermissions?.includes(selectedPermission),
    );
    changePermissionsHandler(updatedSelectedPermissions);
    handleClosePopup();
  };

  const toggleAllPermissions = (allPermissions, hasAllPermissions, showConfirmationPopup = false) => {
    if (typeof changePermissionsHandler !== 'function') return;
    if (hasAllPermissions && showConfirmationPopup) {
      setOpenPopup(true);
      setSelectedModulePermissions(allPermissions);
    } else if (hasAllPermissions) {
      const updatedSelectedPermissions = selectedPermissions?.filter(
        selectedPermission => !allPermissions?.includes(selectedPermission),
      );
      changePermissionsHandler(updatedSelectedPermissions);
    } else {
      changePermissionsHandler([...selectedPermissions, ...allPermissions]);
    }
  };

  const togglePermission = useCallback(
    stepId => {
      if (typeof changePermissionsHandler !== 'function') return;
      const filteredServices = selectedPermissions.filter(item => item !== stepId);
      if (selectedPermissions?.length === filteredServices?.length) {
        filteredServices.push(stepId);
      }
      changePermissionsHandler([...filteredServices]);
    },
    [dispatch, selectedPermissions, changePermissionsHandler],
  );

  return (
    <>
      <div className={classes.container}>
        {permissions?.groupPermissions?.map(item => {
          const modulePermissions = (item?.permissionList ?? []).reduce((permissionsResult, currentPermission) => {
            const newPermissions = (currentPermission?.stepPermissionList ?? [])?.map(
              curPermissionItem => curPermissionItem?.stepId,
            );
            return [...permissionsResult, ...newPermissions];
          }, []);
          const hasAllModulePermissions = !modulePermissions?.some(
            permission => !selectedPermissions?.includes(permission),
          );
          const hasAnyModulePermission = modulePermissions?.some(permission =>
            selectedPermissions?.includes(permission),
          );
          return (
            <Accordion
              className={classes.accordionFrame}
              key={item?.groupId}
              // onChange={(_, expanded) => {
              //   if (expanded) {
              //     setExpandedPermission(item?.groupId);
              //   }
              // }}
            >
              <AccordionSummary
                className={classes.accordionSummary}
                aria-controls={`panel1a-content-${item?.groupId}`}
                id={`panel1a-header-${item?.groupId}`}
                expandIcon={<ADGMImage name='rounded-down-arrow.svg' alt='arrow' />}
              >
                <ADGMCheckbox
                  label={item[langKeys.groupName]}
                  checked={hasAllModulePermissions || hasAnyModulePermission}
                  indeterminateChecked={!hasAllModulePermissions && hasAnyModulePermission}
                  onChangeHandler={() => toggleAllPermissions(modulePermissions, hasAllModulePermissions, true)}
                  onClick={event => event.stopPropagation()}
                  onFocus={event => event.stopPropagation()}
                />
              </AccordionSummary>
              <AccordionDetails className={classes.accordionDetails}>
                {item?.permissionList?.map(perList => {
                  const servicePermissions = perList?.stepPermissionList?.map(stepPermission => stepPermission?.stepId);
                  const hasAllServicePermissions = !servicePermissions?.some(
                    permission => !selectedPermissions?.includes(permission),
                  );
                  const hasAnyServicePermission = servicePermissions?.some(permission =>
                    selectedPermissions?.includes(permission),
                  );
                  return (
                    <div className={classes.mainServiceContainer}>
                      <ADGMCheckbox
                        label={perList[langKeys.serviceName]}
                        checked={hasAllServicePermissions || hasAnyServicePermission}
                        indeterminateChecked={!hasAllServicePermissions && hasAnyServicePermission}
                        onChangeHandler={() => toggleAllPermissions(servicePermissions, hasAllServicePermissions)}
                      />
                      {perList?.stepPermissionList?.length > 0 && (
                        <div className={classes.checkboxHolderFlex}>
                          {perList?.stepPermissionList?.map(elm => (
                            <ADGMCheckbox
                              key={elm?.stepId}
                              label={elm[langKeys.stepName]}
                              checked={selectedPermissions?.includes(elm?.stepId)}
                              onChangeHandler={() => togglePermission(elm?.stepId)}
                              customClasses={{ checkboxRoot: classes.permissionCheckBoxHolder }}
                            />
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}
              </AccordionDetails>
            </Accordion>
          );
        })}
      </div>
      {openPopup && (
        <ADGMAcknowledgementPopup
          open={openPopup}
          title={keyEmptyCheck('remove_permissions_confirmation_title')}
          description='remove_permissions_confirmation_text'
          cancelBtnText='discard'
          proceedBtnText='yes'
          onCloseHandler={handleClosePopup}
          onCancelHandler={handleClosePopup}
          onProceedHandler={handleRemoveModulePermissions}
        />
      )}
    </>
  );
}

EditablePermissions.propTypes = {
  classes: PropTypes.object.isRequired,
  langKeys: PropTypes.object.isRequired,
  permissions: PropTypes.object.isRequired,
  selectedPermissions: PropTypes.array.isRequired,
  changePermissionsHandler: PropTypes.func.isRequired,
};

export default withStyles(styles)(EditablePermissions);
